(function () {
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function initUpsells(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-upsell-add]').forEach((button) => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';

      button.addEventListener('click', () => {
        const variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        button.classList.add('is-loading');
        button.disabled = true;

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);

        fetch(`${window.routes?.cart_add_url || '/cart/add'}`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) throw response;
            const drawer = getCartDrawer();
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.classList.remove('is-empty');
              drawer.renderContents(response);
            }
          })
          .catch(() => {
            button.disabled = false;
          })
          .finally(() => {
            button.classList.remove('is-loading');
          });
      });
    });

    scope.querySelectorAll('[data-upsell-variant-select]').forEach((select) => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';

      select.addEventListener('change', () => {
        const card = select.closest('.sc-cart-upsell-card');
        const button = card?.querySelector('[data-upsell-add]');
        if (button) {
          button.dataset.variantId = select.value;
        }
      });
    });
  }

  function initCartLinks() {
    document.querySelectorAll('[data-sc-cart-toggle]').forEach((link) => {
      if (!link.querySelector('.header-cart-icon') || link.dataset.cartUiBound) return;
      link.dataset.cartUiBound = 'true';

      link.addEventListener('click', (event) => {
        const drawer = getCartDrawer();
        if (!drawer) return;

        event.preventDefault();
        drawer.open(link);
      });
    });
  }

  function initAll(root) {
    initUpsells(root);
    initCartLinks();
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      requestAnimationFrame(() => initAll(document.getElementById('CartDrawer')));
    });
  }

  document.addEventListener('cart-drawer:opened', () => initAll(document.getElementById('CartDrawer')));
})();
